var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReviewStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_8012_847",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_8012_847",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAACNklEQVRYw72WsW/aQBTGPx9uYlpUWfUQpEZyl0pM0LEb/0AqeeyCRJcof0Kmrq3UhWzZoMpcyRIS6lZnY2wyIWUBCRQzWEHEio0x5y6YGLDqszF+k7GO9/vuu/eej+uf1EUAKoAqso1rAArvwwuShMNCIRPyzDRhGkYVgEr8nSeBk+Micu/fxf5fgFUlu+xEqCkQTj/v5EZiAUQSQd4WweWFRC7sLCBXLq2e+UopewEvPn54FlDOWIBvvx/cGxHkuJhIAB+14NWPc3B5ITLRy/OzrXeeZePpawOeZSd3YHHbS2wvHer/hTM5YF+p4G96OKwpTE74O3c6GuZ/uunUgHvbg/X9Eou7fvSuRzqsixYTPFYRUmMC66IVuc5qtECH+n66gKXd4s6EeAIYkufKexSwmdzpaJj9+r1W6Xy5xFysTF0QlpiOdNhX6uqsF3d9CDVlNZz4Sgnz7t90HeAkEQAw17pbhUaHOp6+XcLpaKvJyJy3f1L3AECS5ejFeSFysBBJBDUmkbmMwSB+DUTB/XbN5GuYVpDgPS2rCLL45e20ahoGTMN4Pm9C8ProCPzBQbjVrgvr8REz04RHaeKbMQGgLEWsnzelmI7H4d8Gx8Hk/h72dLoTHIDCeZ639nbw6YsIQANQCesO13EwHY998DWAhtxuqklVbAkIiHjYFLAB/ym3m/XUijAYcrs5CbM9bTjTKKauC7qsh7ThTAIeRqPgz1ThcQdR6vA4AvYCjxJws284APwDSFn6uedpwS4AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewStar);
export default __webpack_public_path__ + "static/media/review_star.fb62f306ac461ce40b7138d1b312fc67.svg";
export { ForwardRef as ReactComponent };